/**
 * FAQ ページ専用の JS
 * Stiletto v5.2.2 移行対応 (2026-04-27)
 *
 * 役割1: body に page-faq クラスを追加
 *   → assets/faq-fix.css の `.page-faq` セレクタを有効化
 *   → ページタイトル <h1> が表示される
 *
 * 役割2: ページ内リンクの href の shopify-section-template--XXXX__ プレフィックスを
 *   現在のテーマのテンプレートIDに動的に書き換え
 *   → templates/page.faq.json には旧テーマID `template--19228526346550` が
 *     ハードコードされており、新テーマではIDが違うためリンクが効かない問題に対応
 *
 * 役割3: ページ内ハッシュリンクのスムーススクロール + フォールバック検索
 *   → href 完全一致で見つからない場合、サフィックス部分一致で対象を探す
 *   → テンプレートID prefix が変わっても、セクションキー（__YYY）で安定して動作
 */
(function() {
  'use strict';

  function addBodyClass() {
    document.body.classList.add('page-faq');
  }

  function fixFaqLinks() {
    // ページ内ハッシュリンクで shopify-section-template-- を含むものをすべて取得
    var links = document.querySelectorAll('a[href*="#shopify-section-template--"]');
    if (links.length === 0) {
      return;
    }

    // 現在のページの最初の shopify-section から、テンプレートID prefix を取得
    // 例: "shopify-section-template--26426269991222__main" → "shopify-section-template--26426269991222"
    var firstSection = document.querySelector('[id^="shopify-section-template--"]');
    if (!firstSection) {
      return;
    }

    var match = firstSection.id.match(/^(shopify-section-template--\d+)__/);
    if (!match) {
      return;
    }
    var currentPrefix = match[1];

    // すべての該当リンクの href を、現在のテーマの prefix に置換
    links.forEach(function(link) {
      var oldHref = link.getAttribute('href');
      var newHref = oldHref.replace(
        /#shopify-section-template--\d+__/,
        '#' + currentPrefix + '__'
      );
      if (newHref !== oldHref) {
        link.setAttribute('href', newHref);
      }
    });
  }

  /**
   * href から対象要素を取得する。完全一致で見つからなければ、
   * サフィックス部分一致でフォールバック検索する。
   * テンプレートID prefix が予期しない値でも安定して動作するため。
   */
  function getTargetElement(href) {
    if (!href || href === '#' || href.length < 2) {
      return null;
    }

    // 1) まず href の完全一致を試す
    try {
      var direct = document.querySelector(href);
      if (direct) {
        return direct;
      }
    } catch (err) {
      // 無効なセレクタなら次の方法へ
    }

    // 2) shopify-section-template--XXX__YYY 形式なら、サフィックス部分一致でフォールバック
    var match = href.match(/^#shopify-section-template--\d+__(.+)$/);
    if (match) {
      var sectionKey = match[1];
      try {
        // 属性セレクタの値部分を二重引用符で囲み、含まれる " と \ をエスケープ
        var escapedKey = sectionKey.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        var fallback = document.querySelector('[id$="__' + escapedKey + '"]');
        if (fallback) {
          return fallback;
        }
      } catch (err) {
        // 属性セレクタが無効なら諦める
      }
    }

    return null;
  }

  /**
   * ページ内ハッシュリンクのスムーススクロール
   */
  function enableSmoothScroll() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) {
        return;
      }

      var href = link.getAttribute('href');
      var target = getTargetElement(href);
      if (!target) {
        // 対象が見つからない場合はデフォルト動作に任せる
        return;
      }

      // 既定のジャンプを止めてスムーススクロール
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // 実際にスクロールした要素の id で URL を更新
      // （href が古い prefix のままでも、URL は実体に合わせる）
      if (target.id && history.pushState) {
        history.pushState(null, '', '#' + target.id);
      }
    });
  }

  function init() {
    addBodyClass();
    fixFaqLinks();
    enableSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
